angular.module('manufacturing')
    .service('ManufacturingOrderCalendarV4Service', function ($rootScope, $timeout, $stateParams, $location, $state, $compile, Principal, ManufacturingOrderService, NoteService) {
        let handleManufacturingClick = function (info) {
            return ManufacturingOrderService.open(info.event.id);
        }
        let handleNoteClick = function (info) {
            if (!Principal.hasAnyAuthority(['ROLE_NOTES'])) return;
            return NoteService.showModal(info.event.id);
        }
        const eventClickHandlers = {
            MANUFACTURING: handleManufacturingClick,
            NOTE: handleNoteClick,
        };


        let eventRenderManufacturing = function (info) {
            let event = info.event;

            let status = event.extendedProps.status;
            let clientSymbol = event.extendedProps.companies;
            let address = event.extendedProps.address;
            let number = event.id;
            let phone = event.extendedProps.phone;
            let notes = event.extendedProps.notes;
            let nodes = event.extendedProps.nodes;
            let commentsCount = event.extendedProps.commentsCount;
            let quantity = event.extendedProps.quantity;
            let unit = event.extendedProps.unit;
            let productName = event.extendedProps.productName;
            let productSymbol = event.title;
            if (productName == null && typeof productSymbol === 'string' && productSymbol.includes(' ')) {
                let separatorIndex = productSymbol.indexOf(' ');
                productName = productSymbol.substring(separatorIndex + 1);
                productSymbol = productSymbol.substring(0, separatorIndex);
            }
            let locationId = event.extendedProps.locationId;
            let vehicle = event.extendedProps.vehicle;
            let vehicleFullName = event.extendedProps.vehicleFullName || vehicle;
            let vehicleLocationId = event.extendedProps.vehicleLocationId;
            let vehicleLocationName = event.extendedProps.vehicleLocationName;
            let isNotSelectedLocation = $stateParams.location != null && locationId != null && $stateParams.location !== locationId;
            let isVehicleFromDifferentLocation = (vehicleLocationId != null && vehicleLocationId !== locationId) || false;
            let locationAcceptanceStatus = event.extendedProps.locationAcceptanceStatus;
            let vehicleLocationAcceptanceStatus = event.extendedProps.vehicleLocationAcceptanceStatus;
            let isClientStatusAcceptanceRequired = event.extendedProps.clientStatusAcceptanceRequired;
            let linked = event.extendedProps.linked;

            // Create event content container
            let container = document.createElement('div');
            container.classList.add('manufacturing-event-container');

            let leftColumn = document.createElement('div');
            leftColumn.classList.add('custom-event-left');

            let rightColumn = document.createElement('div');
            rightColumn.classList.add('custom-event-right');
            let rightColumnTooltip = [vehicleLocationName ? `Oddział: ${vehicleLocationName}` : null, vehicleFullName ? `Pojazd: ${vehicleFullName}` : null].filter(Boolean).join('\n');
            if (rightColumnTooltip) rightColumn.title = rightColumnTooltip;

            // Left column content
            let row1 = document.createElement('div');
            row1.classList.add('custom-event-row', 'truncate-text');
            row1.innerHTML = `<strong>${event.start.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}</strong> - <span class="event-client">${clientSymbol}</span>`;
            leftColumn.appendChild(row1);



            if (!isNotSelectedLocation && productSymbol != null) {
                let row = document.createElement('div');
                row.classList.add('custom-event-row', 'truncate-text');


                if (number != null) {
                    let num = document.createElement('div');
                    num.classList.add('manufacturing-number');
                    num.innerText = "#" + number;
                    row.appendChild(num);
                }

                let product = document.createElement('div');
                product.classList.add('manufacturing-product');
                product.innerText = productSymbol;
                row.appendChild(product);

                if (productName != null) {
                    let name = document.createElement('div');
                    name.classList.add('manufacturing-product-name');
                    name.innerText = productName;
                    row.appendChild(name);
                }

                if (quantity != null) {
                    let qty = document.createElement('div');
                    qty.classList.add('manufacturing-quantity');
                    let quantityUnitLine = ` ${quantity}`;
                    if (unit != null) {
                        quantityUnitLine += ` ${unit}`;
                    }
                    qty.innerText = quantityUnitLine;
                    row.appendChild(qty);
                }

                leftColumn.appendChild(row);
            }

            if (vehicle != null) {
                let plates = document.createElement('div');
                plates.classList.add('custom-event-row', 'event-vehicle');
                if (!isNotSelectedLocation) {
                    plates.classList.add(`same-location-vehicle-${isVehicleFromDifferentLocation}`);
                }
                plates.innerText = `${vehicle}`;
                rightColumn.appendChild(plates);
            }
            if (!['COMPLETED', 'CANCELLED'].includes(status)) {
                let warnings = document.createElement('div');
                warnings.classList.add('manufacturing-event-warnings', 'text-danger');
                if (locationAcceptanceStatus != null) {
                    warnings.innerHTML += `<i class="fa fa-fw fa-industry ${locationAcceptanceStatus}" title="Akceptacja oddziału zamówienia"></i>`;
                }
                if (vehicleLocationAcceptanceStatus != null) {
                    warnings.innerHTML += `<i class="fa fa-fw fa-car ${vehicleLocationAcceptanceStatus}" title="Akceptacja oddziału pojazdu"></i>`;
                }
                if (isClientStatusAcceptanceRequired) {
                    warnings.innerHTML += `<i class="fa fa-fw fa-exclamation-triangle" title="Klient nie jest w pełni aktywny - brak potwierdzenia"></i>`;
                }
                rightColumn.appendChild(warnings);
            }

            if (commentsCount > 0) {
                let comments = document.createElement('div');
                comments.classList.add('custom-event-row', 'event-comments');
                comments.innerHTML = `<span class="document-info-header" title="Komentarzy: ${commentsCount}"><i class="fa fa-fw fa-comment-o"></i>${commentsCount}</span>`;
                rightColumn.appendChild(comments);
            }
            if (linked) {
                let link = document.createElement('div');
                link.classList.add('custom-event-row', 'manufacturing-order-link-indicator');
                link.innerHTML = '<i class="fa fa-fw fa-link" title="Zamówienie powiązane z innym"></i>';
                rightColumn.appendChild(link);
            }

            container.appendChild(leftColumn);
            container.appendChild(rightColumn);

            info.el.innerHTML = '';
            info.el.appendChild(container);

            let containerDetails = document.createElement('div');
            containerDetails.classList.add('manufacturing-details-container');

            if (nodes != null) {
                let content = document.createElement('span');
                content.innerHTML += `<i class="fa fa-fw fa-krw" title="Węzeł"></i>${nodes}`;
                containerDetails.appendChild(content);
            }
            if (phone != null) {
                let content = document.createElement('span');
                content.innerHTML += `<i class="fa fa-fw fa-mobile-phone" title="Numer kontaktowy"></i>${phone}`;
                containerDetails.appendChild(content);
            }
            if (notes != null && notes !== "") {
                let content = document.createElement('span');
                content.innerHTML += `<i class="fa fa-fw fa-sticky-note-o" title="Uwagi"></i>${notes}`;
                containerDetails.appendChild(content);
            }
            if(address != null && address !== "") {
                let div = document.createElement('div');
                let addressElement = document.createElement('span');
                addressElement.innerHTML = `<i class="fa fa-fw fa-map-o" title="Adres dostawy"></i>${address}`;
                div.appendChild(addressElement);
                containerDetails.appendChild(div);
            }
            info.el.appendChild(containerDetails);


            if (isNotSelectedLocation) {
                info.el.classList.add('different-location');
            }
            return info;
        }
        let eventRenderNote = function (info) {
            let event = info.event;

            let clientSymbol = event.extendedProps.companies;
            let commentsCount = event.extendedProps.commentsCount;
            let container = document.createElement('div');
            container.classList.add('note-event-container', 'truncate-2-lines-text');

            let leftColumn = document.createElement('div');
            leftColumn.classList.add('custom-event-left');

            let rightColumn = document.createElement('div');
            rightColumn.classList.add('custom-event-right');

            if(clientSymbol != null){
                let item = document.createElement('span');
                item.classList.add('event-client');
                item.innerHTML = `${clientSymbol}&nbsp;`;
                leftColumn.appendChild(item);
            }
            let item = document.createElement('span');
            item.innerHTML = `${event.title}`;
            leftColumn.appendChild(item);

            if (commentsCount > 0) {
            let comments = document.createElement('span');
                comments.classList.add('document-info-header');
                comments.title = `Komentarzy: ${commentsCount}`;
                comments.innerHTML = `<i class="fa fa-fw fa-comment-o"></i>${commentsCount}`;
                rightColumn.appendChild(comments);
            }

            container.appendChild(leftColumn);
            container.appendChild(rightColumn);

            info.el.innerHTML = '';
            info.el.appendChild(container);
            return info
        }
        const eventRenders = {
            MANUFACTURING: eventRenderManufacturing,
            NOTE: eventRenderNote,
        };

        this.eventClick = info => {
            const model = info.event.extendedProps.model;
            const handler = eventClickHandlers[model];

            if (handler) {
                handler(info);
            } else {
                console.warn(`No handler for event type: ${model}`);
            }
        };
        const restoreEventFromSource = info => {
            if (info.event.source) {
                info.event.source.refetch();
            } else {
                info.revert();
            }
        };
        let eventDropNote = function(info) {
            if (!Principal.hasAnyAuthority(['ROLE_NOTES'])) {
                restoreEventFromSource(info);
                return;
            }
            if(info.event.allDay !== true)
                info.revert();

            let properties = {
                dateOfIssue: moment(info.event.start).format('YYYY-MM-DD'),
            }
            NoteService.editModalSimpleWith(info.event.id, properties).catch(() => restoreEventFromSource(info));
        }
        let eventDropManufacturing = function(info) {
            let properties = {
                deliveryTime: info.event.start
            }
            ManufacturingOrderService.edit(info.event.id, properties).catch(() => restoreEventFromSource(info));
        }

        const eventDropHandlers = {
            MANUFACTURING: eventDropManufacturing,
            NOTE: eventDropNote,
        };
        this.eventDrop = (info) => {
            const model = info.event.extendedProps.model;
            const handler = eventDropHandlers[model];

            if (handler) {
                handler(info);
            } else {
                console.warn(`No handler for event type: ${model}`);
            }
        }
        this.selectAllow = function (info) {
            if(info.end == null)
                return true;
            let is30min = moment(info.start).add(30, "m").isSame(info.end);
            return is30min;
        };

        let clickTimer = null;
        const dblClickDelay = 400; // ms
        this.dateClick = function (info) {
            if (clickTimer) {
                clearTimeout(clickTimer);
                clickTimer = null;

                // dbl click action
                if (Principal.hasAnyAuthority(['ROLE_NOTES'])) {
                    let properties = {
                        dateOfIssue: moment(info.date).format('YYYY-MM-DD'),
                        showInCalendar: true,
                        subscriberGroups: [],
                    }
                    NoteService.addModalSimpleForGroup(properties, $stateParams.groupName);
                } else {
                    let properties = { deliveryTime: info.date };
                    properties.location = $stateParams.location;
                    ManufacturingOrderService.add(properties);
                }
                // end
            } else {
                clickTimer = setTimeout(() => {
                    clickTimer = null;
                    // Single click action
                    let properties = { deliveryTime: info.date };
                    properties.location = $stateParams.location;
                    ManufacturingOrderService.add(properties);
                    // end
                }, dblClickDelay);
            }
        }
        this.defaultConfig = (options) => {
            let isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent));
            let height = isMobile ? "auto" : 850;
            let defaultOptions = {
                plugins: ['dayGrid', 'timeGrid', 'list', 'interaction'],
                header: {left: 'today, prev,next', center: 'title', right: 'dayGridDay,dayGridWeek,dayGridMonth'},
                defaultView: "dayGridDay",
                hiddenDays: [ 0 ],
                locale: 'pl',
                weekNumbers: true,
                businessHours: {
                    dow: [1, 2, 3, 4, 5],
                    start: '8:00',
                    end: '17:00',
                },
                height: height,
                displayEventTime: true,
                displayEventEnd: false,
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false
                },
                dateClick: this.dateClick,
                eventClick: this.eventClick,

                editable: true,

                droppable: false,
                eventDrop: this.eventDrop,

                eventResizableFromStart: false,
                eventDurationEditable: false,
                // eventResize: this.eventResize,

                selectable: false,
                // selectAllow: this.selectAllow,
                // select: this.select,

                // dateClick: this.dateClick,
                eventRender: function (info) {
                    const model = info.event.extendedProps.model;
                    const handler = eventRenders[model];

                    if (handler) {
                        handler(info);
                    } else {
                        console.warn(`No handler for event type: ${model}`);
                    }
                },
                viewSkeletonRender: function (info) {
                    let viewName = info.view.type;
                    $state.go($state.current, {
                        view: viewName
                    }, {
                        notify: false, // prevent reloading the controller
                        location: 'replace' // replace browser history entry
                    });

                    // $timeout(function () {
                    //     $location.search('view', viewName);
                    //     $location.replace();
                    // });
                }
            };
            angular.extend(defaultOptions, options);
            return defaultOptions;
        }
    })
